import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TravelSchedulerTask } from 'src/app/interfaces/travel-scheduler/travel-scheduler-task';
import { ButtonModule } from 'primeng';
import { VmePipesModule } from '../../../vme-pipes.module';
import { getTransportModeIcon, getTransportModeText } from '../../../utils/travel-scheduler-utils';
import { TransportIconSwitchComponent } from '../transport-icon-switch/transport-icon-switch.component';
import { TravelSchedulerService } from '../../../services/travel-scheduler.service';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VerticalDotsContainerComponent } from '../../../modules/driver-experience/job-list/vertical-dots-container.component';
import { ChecklistCategoryItemModule } from '../../checklist-category-item/checklist-category-item.module';

@Component({
  selector: 'travel-scheduler-summary-task',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    VmePipesModule,
    TransportIconSwitchComponent,
    VerticalDotsContainerComponent,
    ChecklistCategoryItemModule,
  ],
  templateUrl: './travel-scheduler-summary-task.component.html',
  styleUrls: ['./travel-scheduler-summary-task.component.css'],
})
export class TravelSchedulerSummaryTaskComponent implements OnInit, OnChanges {
  @Input() task!: TravelSchedulerTask;

  protected transportModeText: string = '';

  constructor(protected travelSchedulerService: TravelSchedulerService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['task']) {
      this.transportModeText = getTransportModeText(this.task.supplierTransportModeToPickup);
    }
  }

  protected readonly getTransportModeIcon = getTransportModeIcon;
  protected readonly getTransportModeText = getTransportModeText;
  @Output() editScheduleClicked = new EventEmitter();
  @Input() isVME: boolean = false;

  protected onEditSchedule() {
    this.editScheduleClicked.emit();
  }
}
